import { connect } from 'react-redux';

import { RouterSelectors } from '@zapier/toolbox-redux-framework';

import { isCurrentAppIntentionPublic } from 'app/developer-v3/selectors';

import Sidebar from './Sidebar';

const mapStateToProps = state => {
  const currentUrl = RouterSelectors.currentUrl(state) || '';
  const isPublicIntention = isCurrentAppIntentionPublic(state);

  return { currentUrl, isPublicIntention };
};

export default connect(mapStateToProps)(Sidebar);
